module.exports = __webpack_public_path__ + "img/safetypay.0edbb61.png";